import React, { useRef, useState } from 'react';
import { RentalExtensionRequest } from '../../../../services/entities/requests/rental-extension-request';
import { doExtendRentalFunctionality } from '../../../../shared/api/common-api';
import { HTTP_VERB, RequestHandleType } from '../../../../shared/utility/enum-utility';
import CalculatePriceForm from '../component/calculate-price-form';
import ExtensionPricing from '../component/extension-pricing';

function ExtendRentalForm(props) {
    const scrollRef = useRef(null);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [extensionCharges, setExtensionCharges] = useState(null);
    const { formValue, prevStep, reservationInfo, authorizeRentalExtension, extensionResponse, errorData, setLoader, closeModal } = props;
    const onConfirmRentalExtension = () => {
        const { rentalExtension } = extensionCharges;
        const confirmReq = {
            ...formValue,
            returnDate: rentalExtension?.returnDate,
            totalAuth: rentalExtension?.totalAuth,
            totalTaxes: rentalExtension?.totalTaxes,
        }
        const request = new RentalExtensionRequest({ rentalExtension: { ...confirmReq } }, HTTP_VERB.POST);
        authorizeRentalExtension(request, RequestHandleType.RESPONSE_ONLY, true);
    }
    const getRentalExtensionCharges = async (request, requestHandleType) => {
        setLoader(true);
        const response = await doExtendRentalFunctionality(request, requestHandleType);
        if (response) {
            setExtensionCharges(response);
            scrollToBottom();
        }
        setLoader(false);
    }
    const validateAuthorizeForm = () => {
        const { rentalExtension } = extensionCharges || {};
        if (rentalExtension?.firstName
            && rentalExtension?.lastName
            && rentalExtension?.email
            && rentalExtension?.rentalAgreementNum
            && rentalExtension?.returnDate
            && rentalExtension?.totalAuth
            && rentalExtension?.totalTaxes
            && isConfirmed) {
            return true
        }
        return false;
    }
    const scrollToBottom = () => {
        scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <div className='extend-rental-div'>
            <div className='flex-row gap-2 extend-charge-container'>
                <CalculatePriceForm
                    reservationInfo={reservationInfo}
                    extensionResponse={extensionResponse}
                    extensionCharges={extensionCharges}
                    getRentalExtensionCharges={getRentalExtensionCharges}
                    errorMsg={extensionCharges?.message && extensionCharges?.message?.messageType === "ERROR" ? extensionCharges?.message : null}
                >
                    <div ref={scrollRef}></div>
                </CalculatePriceForm>
                <ExtensionPricing confirmRentalExtension={doExtendRentalFunctionality}
                    extensionCharges={extensionCharges}
                    reservationInfo={reservationInfo}
                    errorMsg={errorData}
                    errorChargeMsg={extensionCharges?.message && extensionCharges?.message?.messageType === "ERROR" ? extensionCharges?.message : null}
                    isConfirmed={isConfirmed}
                    setIsConfirmed={setIsConfirmed}
                    rentalAgreementNum={extensionResponse?.rentalExtension?.rentalAgreementNum}
                />
            </div>
            <hr />
            <div className='btn-container m-0'>
                <button className='btn btn-secondary' onClick={() => closeModal()}>Cancel</button>
                <button className='btn btn-primary' onClick={prevStep}>Prev</button>
                <button className='btn btn-yellow-default' onClick={onConfirmRentalExtension} disabled={!validateAuthorizeForm()}>Authorize</button>
            </div>
        </div>
    )
}

export default ExtendRentalForm